export const modes = {
  edit: 'EDIT',
  review: 'REVIEWING',
};
